import { Box } from "@mui/material";
import { useSipClient } from "@dvrt/web-phone-client";
import Item from "./item/Container";
import { useParticipantList } from "../hooks";
import { Header } from "../widgets";
import { FormattedMessage } from "react-intl";

const ParticipantListContainer = () => {
    const sipClient = useSipClient();

    const participants = useParticipantList();
    const enabled = !!sipClient.session;

    return (
        <div>
            <Header>
                <FormattedMessage
                    id="meetingPage.room.sidebar.participants.header"
                    defaultMessage="Participants ({cnt, number})"
                    values={{ cnt: enabled ? participants.length : 0 }}
                />
            </Header>
            {participants.length && enabled ? (
                <div>
                    {participants.map((p) => (
                        <Item key={`${p.cname}-${p.screen}`} data={p} />
                    ))}
                </div>
            ) : (
                <Box sx={{ margin: "1em", fontStyle: "italic" }}>
                    <FormattedMessage id="meetingPage.room.sidebar.participants.empty" defaultMessage="Wow, so empty" />
                </Box>
            )}
        </div>
    );
};

export default ParticipantListContainer;
